import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-read-notification',
  templateUrl: './read-notification.component.html',
  styleUrl: './read-notification.component.scss'
})
export class ReadNotificationComponent {
  @Input() notificationData: any;

  constructor(private _activeModal: NgbActiveModal) { }

  onClose(): void {
    this._activeModal.close();
  }
}
